import * as React from 'react';
import { Box, IconButton, Typography, Tooltip } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { context } from '../context';

export const SubtitleButtonGroup = ({subtitles, match, setMatch}) => {

    const { pinyinChecked } = React.useContext(context);

    const onMatchDown = (e) => {
        for (let i = match + 1; i < subtitles.length; ++i) {
            if (pinyinChecked) {
                if (subtitles[i].matchMode !== 1 && subtitles[i].matchMode !== 2) {
                    continue;
                }
            } else {
                if (subtitles[i].matchMode !== 1) {
                    continue;
                }
            }
            setMatch(i);
            break;
        }
    }

    const onMatchUp = (e) => {
        for (let i = match - 1; i >= 0; --i) {
            if (pinyinChecked) {
                if (subtitles[i].matchMode !== 1 && subtitles[i].matchMode !== 2) {
                    continue;
                }
            } else {
                if (subtitles[i].matchMode !== 1) {
                    continue;
                }
            }
            setMatch(i);
            break;
        }
    }

    return (
        <Box sx={{ 
            display: 'flex', 
            alignItems: 'center',
            gap: 0.5,
        }}>
            <Typography 
                variant="caption" 
                sx={{ 
                    color: 'text.secondary',
                    fontSize: '0.75rem',
                    fontWeight: 500,
                    mr: 0.5,
                }}
            >
                导航
            </Typography>
            <Tooltip title="上一条" arrow>
                <IconButton 
                    size="small"
                    onClick={onMatchUp}
                    sx={{ 
                        border: '1px solid',
                        borderColor: 'divider',
                        borderRadius: '6px',
                        p: 0.5,
                        '&:hover': {
                            borderColor: 'primary.light',
                            bgcolor: 'rgba(255, 139, 147, 0.06)',
                        },
                    }}
                >
                    <KeyboardArrowUpIcon sx={{ fontSize: '1rem', color: 'text.secondary' }} />
                </IconButton>
            </Tooltip>
            <Tooltip title="下一条" arrow>
                <IconButton 
                    size="small"
                    onClick={onMatchDown}
                    sx={{ 
                        border: '1px solid',
                        borderColor: 'divider',
                        borderRadius: '6px',
                        p: 0.5,
                        '&:hover': {
                            borderColor: 'primary.light',
                            bgcolor: 'rgba(255, 139, 147, 0.06)',
                        },
                    }}
                >
                    <KeyboardArrowDownIcon sx={{ fontSize: '1rem', color: 'text.secondary' }} />
                </IconButton>
            </Tooltip>
        </Box>
    );
}